export default __webpack_public_path__ + "static/media/phone_icon.020d7acb.svg";